import { useSelector } from 'react-redux';
import { isCompetitionEnded, isFinalTrainingTeams, schoolInFinal, teamMember } from '../../ui/builders/utils';
import { useState } from 'react';
import { openGameByProvider } from '../../utils/providerOpenHandlers';
import { selectCurrentStage } from '../../store/selectors/selectContestStages';
import Icon from '../ui/icons/Icon';
import iconsList from '../ui/icons/iconsList';
import BreakPopup from './breakPopup/BreakPopup';
import classes from './BtnPlay.module.scss';

const BtnPlay = ({ text, className }) => {

    const { texts, lang } = useSelector(state => state.translate);
    const currentStage = useSelector(selectCurrentStage);
    const { activeContests, currentContestId } = useSelector(state => state.contest);
    const contestState = useSelector(state => state.contest);
    const [showPopup, setShowPopup] = useState(false);
    const currentContest = activeContests?.find((c) => String(c.id) === String(currentContestId));
    const handleClick = () => {
        if (!currentStage)
            return;
        if(currentContest.openedDueToEmergency) {
            openGame();
            return;
        }
        if (currentStage.isLock === true ||  (isCompetitionEnded(contestState) && !isInFinalTraining) )
            setShowPopup(true);
        else {
            openGame();
        }
    };

    const isInFinalTraining = isFinalTrainingTeams(contestState) && teamMember(contestState);
    
    const openGame = () => {
        openGameByProvider(currentContest?.providers?.[0], lang);
    }

    if(isCompetitionEnded(contestState) && !currentContest.openedDueToEmergency) 
        return null;
    
    return (
        <>
            <div className={classes.btnPlayWrapper}>
                <div className={classes.buttonWrapper}>
                    <div className={`${classes.button} ${className}`} onClick={handleClick}>
                        <Icon name={iconsList.play} size={'40px'} />
                        <p className={classes.text}>{text || texts["btnPlay"]}</p>
                    </div>
                </div>
                {isInFinalTraining && <p className={classes.finalStageText}>{texts.finalStageText}</p>}
            </div>
            <div className={`${classes.desktopMessage} ${className}`}>
                <Icon name={iconsList.desktop} size={'24px'} className={classes.desktopIcon} />
                <p className={classes.desktopText}>{texts["moveToDesktop"]}</p>
            </div>
            {showPopup && <BreakPopup onClose={() => setShowPopup(false)} />}
        </>
    );
};

export default BtnPlay;

